/**
 * Obtiene la URL correcta de una imagen, ya sea de Firebase Storage o local
 * @param {string} imagenURL - URL de la imagen o nombre del archivo
 * @returns {string} URL completa de la imagen
 */
export const obtenerURLImagen = (imagenURL) => {
  if (!imagenURL) {
    return null;
  }

  // Si ya es una URL completa (Firebase Storage u otra URL externa)
  if (imagenURL.includes('http') || imagenURL.includes('firebasestorage')) {
    return imagenURL;
  }

  // Si es una imagen local
  return `/images/${imagenURL}`;
};

